// src/stores/auth.js
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useAuthStore = defineStore('auth', () => {
  const user = ref({ rol: {} })

  const setUser = (data) => {
    user.value = data
  }

  const clearUser = () => {
    user.value = { rol: {} }
  }

  return { user, setUser, clearUser }
})